import { LayoutGrid, Wallet, Route } from "lucide-react";
import { Section, SectionHead } from "@/components/landing/Section";

const ITEMS = [
  { icon: LayoutGrid, t: "3 escapades prêtes à comparer", d: "Recevez immédiatement trois options concrètes adaptées à votre budget et à votre durée. Pas des idées vagues : de vraies options exploitables." },
  { icon: Wallet, t: "Budget clair dès le départ", d: "Visualisez rapidement le coût estimé en train ou en voiture avant d'aller plus loin." },
  { icon: Route, t: "Même zone, zéro zigzag", d: "Chaque escapade regroupe hôtel, activité et restaurant dans une zone cohérente pour éviter les trajets inutiles." },
];

export const Benefits = () => (
  <Section id="benefices">
    <SectionHead eyebrow="Bénéfices" title="Pourquoi Wanderlust est différent" />
    <div className="mt-12 grid md:grid-cols-3 gap-6">
      {ITEMS.map((b, i) => (
        <div key={b.t} data-testid={`benefit-card-${i + 1}`} className="rounded-2xl bg-white border border-gray-200 p-7 hover:border-amber-600/50 hover:shadow-lg transition-[border-color,box-shadow] duration-300">
          <span className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-amber-50 text-amber-700"><b.icon className="w-5 h-5" /></span>
          <h3 className="mt-5 font-serif text-xl font-semibold text-[#0B131E]">{b.t}</h3>
          <p className="mt-2 text-sm text-gray-600 leading-relaxed">{b.d}</p>
        </div>
      ))}
    </div>
  </Section>
);
